import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/games_panel.css */
  .row.pl_max-min_option {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-start !important;
    background: linear-gradient(0deg, rgba(39, 40, 44, 1) 0%, rgba(49, 53, 60, 1) 50%, rgba(39, 40, 44, 1) 100%);
    background: #27282c;
    /* margin: -15px 0; */
    padding: 20px 15px;
  }
  .row.pl_max-min_option .switch_wrapper {
    display: flex;
    flex-flow: column;
    position: relative;
    top: -4px;
  }
  .row.pl_max-min_option .toggle_switch-checkbox ~ .show_maxmin {
    display: none;
  }
  .row.pl_max-min_option .toggle_switch-checkbox:checked ~ .show_maxmin {
    display: flex;
  }
  .row.pl_max-min_option .show_maxmin {
    position: relative;
    margin-top: 30px;
    margin-left: -140px;
    flex-flow: column;
  }
  .row.pl_max-min_option .show_maxmin .max,
  .row.pl_max-min_option .show_maxmin .min {
    flex-direction: row;
    display: flex;
    margin: 0 0 10px 0;
  }
  .row.pl_max-min_option .show_maxmin .min {
    margin: 0;
  }
  .row.pl_max-min_option .show_maxmin fieldset {
    margin: 10px 0 0 0;
    justify-content: flex-start;
    display: flex;
    flex-direction: column;
    width: 50%;
  }
  .row.pl_max-min_option .show_maxmin .max fieldset:nth-child(1),
  .row.pl_max-min_option .show_maxmin .min fieldset:nth-child(1) {
    margin-right: 5px;
    width: 80%;
  }
  .row.pl_max-min_option .show_maxmin fieldset strong {
    font-size: 0.7rem;
    white-space: nowrap;
    /* text-transform: uppercase; */
  }
  .row.pl_max-min_option .show_maxmin input[type='text'] {
    background: hsla(0, 0%, 100%, 0.1);
    padding: 10px 0 10px 16px;
    border-radius: 10px 10px 0 0;
    font-size: 0.8rem;
    width: 100%;
    margin-top: 5px;
  }
  .row.pl_max-min_option .show_maxmin .percent_value_buttons {
    display: flex;
    flex-direction: row;
  }
  .row.pl_max-min_option .show_maxmin .percent_value_buttons button {
    padding: 8px 6px;
    font-size: 0.7rem;
    border-radius: 0;
    border-right: 1px solid hsla(0, 0%, 100%, 0.15);
    min-width: 46px;
  }
  .row.pl_max-min_option .show_maxmin .percent_value_buttons button:first-child {
    border-radius: 0 0 0 10px;
    min-width: 36px;
  }
  .row.pl_max-min_option .show_maxmin .percent_value_buttons button:last-child {
    border-radius: 0 0 10px 0;
    border-right: 0;
    min-width: 50px;
  }
  .row.pl_max-min_option .show_maxmin .max .percent_value_buttons button {
    background: hsla(126, 100%, 38%, 0.1);
  }
  .row.pl_max-min_option .show_maxmin .min .percent_value_buttons button {
    background: hsla(340, 88%, 46%, 0.1);
  }
  .row.pl_max-min_option .show_maxmin input[readonly] {
    background: transparent;
    padding-left: 0;
  }
  .row.pl_max-min_option .show_maxmin input.tpsl_result_data {
    padding: 10px;
    border-radius: 10px;
  }
  .row.pl_max-min_option .show_maxmin input[readonly].tpsl_result_data {
    font-weight: 800;
    height: 100%;
  }
  .row.pl_max-min_option .show_maxmin input[readonly].tpsl_result_data.profit {
    color: hsl(126, 100%, 38%);
  }
  .row.pl_max-min_option .show_maxmin input[readonly].tpsl_result_data.loss {
    color: hsla(340, 88%, 46%, 1);
  }
  button {
    width: 100%;
    text-align: center;
    font-size: 0.8rem;
    text-transform: uppercase;
    padding: 15px 0;
    line-height: 100%;
    font-weight: 500;
  }
  button.profit:hover {
    background: hsla(126, 100%, 38%, 0.3) !important;
  }
  button.profit_active {
    background: hsla(126, 100%, 38%, 0.5) !important;
  }
  button.loss:hover {
    background: hsla(340, 88%, 46%, 0.3) !important;
  }
  button.loss_active {
    background: hsla(340, 88%, 46%, 0.5) !important;
  }
  @media (max-width: 1600px) {
    .row.pl_max-min_option .show_maxmin {
      margin-left: -155px;
    }
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/panels.css */
  .row {
    flex-flow: row;
    justify-content: space-between;
    margin: 0;
    padding: 0 15px;
    display: flex;
    align-items: center;
  }
  .subtitle {
    font-weight: 600;
    font-size: 0.75rem;
    white-space: nowrap;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .subtitle {
    align-items: flex-start;
    justify-content: flex-start;
  }
  /*! CSS Used for new profit loss input with wrapper*/
  .row.pl_max-min_option .show_maxmin input.tpsl_result_data {
    font-weight: 800;
    border-radius: 10px;
    padding: 10px 10px 10px 30px;
    position: relative;
    margin: 0;
  }
  .row.pl_max-min_option .show_maxmin input.tpsl_result_data.profit {
    color: hsl(126, 100%, 38%);
  }
  .row.pl_max-min_option .show_maxmin input.tpsl_result_data.loss {
    color: hsla(340, 88%, 46%, 1);
  }
  .row.pl_max-min_option .show_maxmin .input_wrapper {
    position: relative;
    margin-top: 5px;
  }
  .row.pl_max-min_option .show_maxmin .input_wrapper:after {
    position: absolute;
    left: 10px;
    top: calc(50% + 1px);
    transform: translateY(-50%);
    font-size: 0.8rem;
    font-weight: 600;
  }
  .row.pl_max-min_option .show_maxmin .input_wrapper.profit:after {
    content: '$ +';
    color: #00c213;
  }
  .row.pl_max-min_option .show_maxmin .input_wrapper.profit.noContent:after {
    content: '';
    color: #00c213;
  }
  .row.pl_max-min_option .show_maxmin .input_wrapper.loss:after {
    content: '$ -';
    color: #de0e54;
  }
  .row.pl_max-min_option .show_maxmin .input_wrapper.loss.noContent:after {
    content: '';
    color: #de0e54;
  }
`

const developerCSS = css`
  .secondary_slider .stateOption {
    font-size: .7rem;
    padding: 8px 0;
  }

  .secondary_slider .track {
    margin: 10px 0 5px 0;
  }
`

export const PnLThresholdsCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
